import React from 'react';
import barcode from "../../assets/img/barcode.png"
import blackLogo from "../../assets/img/black-logo.png"
import appStore from "../../assets/img/App-Store.png"
import googlePlay from "../../assets/img/Google-Play.png"
import {useTranslation} from "react-i18next";

const AppSection = () => {
  const {t} = useTranslation()
  return (
    <div className={"my-container-small hidden md:flex"}>
      <div className={"flex gap-5 md:mt-20 mb-8"}>
        <div className={"bg-main px-5 flex gap-5 items-center rounded-lg "}>
          <img  className={"flex w-[50px] h-[50px]"} src={blackLogo}/>
          <div className={"flex flex-col"}>
            <span className={"text-white"}>{t('download')}</span>
            <span className={"text-white text-xs"}>{t('downloadDes')}</span>
          </div>
          <div className={"flex gap-2 w-1/2"}>
            <img className={"flex max-w-[180px] max-h-[52px]"} src={appStore}/>
            <img  className={"flex max-w-[180px] max-h-[52px]"} src={googlePlay}/>
          </div>
        </div>
        <div>
          <img  className={"flex max-w-[131px] max-h-[131px]"} src={barcode}/>
        </div>
      </div>
    </div>
  );
};

export default AppSection;
